import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  d: "M8.7 8.2a.7.7 0 1 1-1.4 0V5.7a.7.7 0 1 1 1.4 0zM8 11a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.851 2.496A1.7 1.7 0 0 1 6.048 2h3.903c.449 0 .88.178 1.197.496l2.356 2.355c.318.318.496.75.496 1.199v3.9c0 .45-.179.879-.495 1.196l-2.356 2.357A1.7 1.7 0 0 1 9.95 14H6.048c-.449 0-.88-.178-1.196-.495l-2.356-2.357A1.7 1.7 0 0 1 2 9.952V6.048c0-.449.178-.88.495-1.196zM8 8.9a.7.7 0 0 0 .7-.7V5.7a.7.7 0 1 0-1.4 0v2.5a.7.7 0 0 0 .7.7m-.75 1.35a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=AlertErrorFilledIcon16.js.map